import React from "react";

export default function ColoredDivider({ padding }) {
  return (
    <div>
      <div
        style={{
          width: "100%",
          paddingBottom: padding ? padding : "1px",
          backgroundImage:
            "linear-gradient(90deg, #ffdd00, red, #ff00ea, blue, #00f7ff)",
        }}
      ></div>
    </div>
  );
}
